// Default array element values
export const ASCENDING_ORDER = 'asc';
export const COMMA_SEPARATOR = ',';
export const DESCENDING_ORDER = 'desc';
export const EMPTY = 0;
export const FIRST_ELEMENT = 0;
export const SINGLE_ELEMENT = 1;
export const UNDEFINED = -1;